import { useQuery } from "@tanstack/react-query";
import { getAgentsForSelect } from "../../api/apiAgents";

const QUERY_KEY = ["agents-select"];

const useGetAgentsForSelect = () => {
  const {
    data,
    isLoading,
    isError,
    error,
  } = useQuery({
    queryKey: QUERY_KEY,
    queryFn: getAgentsForSelect,
    staleTime: 5 * 60 * 1000, // 5 minutes cache
  });

  return {
    isLoading,
    error: isError ? error : null,
    agentsOptions: data?.data || [],
  };
};

export default useGetAgentsForSelect;
